import '.br{flex-shrink:0;}.ssr-plugin'
import '.bt{padding:1rem;}.ssr-plugin'
import '.a9{width:100%;}.ssr-plugin'
import '.bl{height:100%;}.ssr-plugin'
import '.b7{border:none;}.ssr-plugin'
import '.b8{background-color:transparent;}.ssr-plugin'
import '.er{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.cm{position:sticky;}.ssr-plugin'
import '.es{top:4rem;}.ssr-plugin'
import '.et{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.eu{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.ev{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a4{position:fixed;}.ssr-plugin'
import '.cn{top:0px;}.ssr-plugin'
import '.bj{left:0px;}.ssr-plugin'
import '.bk{right:0px;}.ssr-plugin'
import '.ew{bottom:0px;}.ssr-plugin'
import '.ex{z-index:9999;}.ssr-plugin'
import '.ey{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.e1{justify-content:flex-end;}.ssr-plugin'
import '.bw{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="br bt a9 bl b7 b8 er"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="cm es et ae eu v ev a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a4 cn bj bk ew ex ae ey a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bt a e1 ev"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bw ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
